import { EstatAccio, ImprovementPlansGanttData } from '../types/index';
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { getImprovementPlansGantt } from '../api/improvementPlanAPI';
import { ImprovementPlanGanttItemDto } from '../types/index';
import { ActionStatusEnum } from '../types/enums';

const mapActionStatus = (status: number): EstatAccio => {
  if (status === ActionStatusEnum.Closed) return 'Closed';
  if (status === ActionStatusEnum.InProgress) return 'InProgress';
  return 'Open';
};

function mapToGanttData(items: ImprovementPlanGanttItemDto[]): ImprovementPlansGanttData {
  const plans = items.map(p => ({
    id: p.id,
    titol: p.titol,
    responsable: p.responsable,
    dataInici: p.dataInici,
    dataFi: p.dataFi,
    estat: 'Open' as const,
    accions: p.accions,
    accionsCompletes: p.accionsCompletes,
  }));

  const accions: ImprovementPlansGanttData['accions'] = {};
  items.forEach(p => {
    accions[p.id] = p.accionsList.map(a => ({
      id: a.id,
      descripcio: a.descripcio,
      responsable: a.responsable,
      dataInici: a.dataInici,
      dataFi: a.dataFi,
      estat: mapActionStatus(a.estat),
    }));
  });

  return { plans, accions };
}

export const useImprovementPlansGantt = () => {
  const filters = useSelector(
    (s: RootState) => s.filters.improvementPlans.selectedFilters
  );
  const filterByUser = useSelector(
    (s: RootState) => s.filters.improvementPlans.filterByUser ?? false
  );

  const query = useQuery<ImprovementPlansGanttData>({
    queryKey: ['improvement-plans-gantt', filters, filterByUser],
    queryFn: async () => {
      const dto = await getImprovementPlansGantt(filters, filterByUser);
      return mapToGanttData(dto.plans);
    },
  });

  return {
    data: query.data ?? { plans: [], accions: {} },
    isLoading: query.isLoading,
    error: query.error,
  };
};
